import { render, staticRenderFns } from "./RadioCards.vue?vue&type=template&id=4c172cd2&scoped=true"
import script from "./RadioCards.vue?vue&type=script&lang=js"
export * from "./RadioCards.vue?vue&type=script&lang=js"
import style0 from "./RadioCards.vue?vue&type=style&index=0&id=4c172cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c172cd2",
  null
  
)

export default component.exports